import React, { useState, useCallback, useRef } from "react";
import { connect } from "react-redux";
import AccordionReact from 'devextreme-react/accordion';
import Toolbar, { Item } from "devextreme-react/toolbar";
import { Button } from 'devextreme-react/button';
import FormField from '../../../dynamicFormBuilder/FormField';
import TransactionsFormLayout from './TransactionsFormLayout';
import { GetLookupStaticData } from "../../../om/services/SalesOrderService";
import { TRANSACTION_TYPES, STAGES, STATUSES, toSelectOptions } from "./codeLists";

const searchpanel = [{ ID: 1, Title: 'Search Filters' }];

const buildInitialFields = () => {
  const init = {
    TransactionType: '', Stage: '', Status: '', TransactionDateFrom: '', TransactionDateTo: '',
    Reference: '', Description: '', FiscalYear: '', FiscalPeriod: '',
  };
  for (let i = 1; i <= 10; i++) { init[`Code${i}`] = ''; init[`Reference${i}`] = ''; }
  return init;
};

// Search panel for the transactions grid — dynamic FormField from TransactionsFormLayout (first 8 fields
// visible, rest via the field chooser). Mirrors the SalesOrderManagement item-master filters.
const TransactionsFilters = (props) => {
  const [selectedItems, setSelectedItems] = useState([]);
  const [forceRender, setForceRender] = useState(false);
  const [formFields, setformFields] = useState(buildInitialFields());
  const formRefs = useRef({});

  const selectionChanged = useCallback((e) => {
    let newItems = [...selectedItems];
    e.removedItems.forEach((item) => { const idx = newItems.indexOf(item); if (idx >= 0) newItems.splice(idx, 1); });
    if (e.addedItems.length) newItems = [...newItems, ...e.addedItems];
    setSelectedItems(newItems);
  }, [selectedItems]);

  const handleFormSubmit = () => { props.searchData(formFields); };
  const handleReset = () => { setformFields(buildInitialFields()); };
  const handleFieldChange = useCallback(() => {}, []);

  const handleFormLoad = useCallback(() => {
    GetLookupStaticData("TransactionType", toSelectOptions(TRANSACTION_TYPES), formRefs, setForceRender, forceRender);
    GetLookupStaticData("Stage", toSelectOptions(STAGES), formRefs, setForceRender, forceRender);
    GetLookupStaticData("Status", toSelectOptions(STATUSES), formRefs, setForceRender, forceRender);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <AccordionReact
      dataSource={searchpanel}
      collapsible={true}
      multiple={false}
      animationDuration={300}
      selectedItems={selectedItems}
      onSelectionChanged={(e) => { if (e.currentTarget === e.target) selectionChanged(e); }}
      itemTitleRender={() => (
        <Toolbar className="accordian-toolbar">
          <Item location="before">
            <div className="title">
              <h6 style={{ color: window._env_.Color2 }}>{props.title || 'IM Item Management'}</h6>
            </div>
          </Item>
          <Item location="after">
            <Button className="accordianButton" onClick={handleFormSubmit} text="Search" type="default" />
          </Item>
          <Item location="after">
            <Button className="accordianButton" onClick={handleReset} text="Reset" />
          </Item>
        </Toolbar>
      )}
      itemRender={() => (
        <div>
          <FormField
            currrentUser={props.currentUser}
            layoutId='0046d046-1f34-4b56-9a21-0046aabbccdd'
            layoutName='ItemManagementTransactions'
            defaultFormSchema={TransactionsFormLayout}
            formFields={formFields}
            setformFields={setformFields}
            handleFieldValueChange={handleFieldChange}
            DYNAMICFORMSETTING={props.DYNAMICFORMSETTING}
            formRefs={formRefs}
            onFormLoad={handleFormLoad}
            noSpacingBeforeFirstRow={true}
          />
        </div>
      )}
      id="accordion-container" className="accordion-height"
    />
  );
};

function mapStateToProps(state) { return { oidc: state.oidc }; }
export default connect(mapStateToProps)(TransactionsFilters);
